import { SigningFlowType } from '../../../lib/types/signingFlowType';

/**
 * All supported source of opening form steps.
 * @enum {string}
 */
export const Source = {
    GOOGLE_ONE_TAP: 'GOOGLE_ONE_TAP'
};

/**
 * All supported identification form steps.
 * @enum {string}
 */
export const Step = {
    INITIAL: 'initial',
    EMAIL_IDENTIFICATION: 'email_identification',
    PROFILE_SETUP: 'profile_setup',
    ACTIVATION: 'activation',
    CHANGE_EMAIL: 'change_email',
    RESET_PASSWORD: 'reset_password',
    SOCIAL_PROVIDER_FALLBACK: 'social_provider_fallback'
};

/**
 * All supported signin modes in the identification form
 * @enum {string}
 */
export const IdentificationMode = {
    UNKNOWN: 'unknown',
    SIGNIN: 'signin',
    SIGNUP: 'signup',
    SOCIAL_SIGNUP: 'social_signup',
    SOCIAL_SIGNIN: 'social_signin',
    GOOGLE_ONE_TAP: 'google_one_tap',
    ACTIVATION: 'activation'
};

/**
 * Maps between an identification mode and signing flow.
 *
 * @type {Object<string>}
 */
export const IdentificationModeToSigningFlow = {
    [IdentificationMode.SIGNIN]: SigningFlowType.signIn,
    [IdentificationMode.SIGNUP]: SigningFlowType.signUp,
    [IdentificationMode.SOCIAL_SIGNUP]: SigningFlowType.socialSignUp
};

export const SOCIAL_PROVIDER_ICON_SIZE = 20;
